"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert1dChainlinkTo2dDualRowZigZag = exports.convert2dDualRowZigZagTo1dChainlink = exports.applyResetModule = exports.applyResetModules = exports.applySetFlaps = void 0;
const splitflapjs_proto_1 = require("splitflapjs-proto");
const applySetFlaps = (config, positions, forceMovement) => {
    if (positions.length > config.modules.length) {
        console.warn(`Ignoring applySetFlaps: mismatch in positions specified (${positions.length}) vs config (${config.modules.length})!`);
        return config;
    }
    if (forceMovement !== undefined && forceMovement.length != positions.length) {
        throw new Error(`forceMovement (${forceMovement.length}) and positions (${positions.length}) length mismatch!`);
    }
    const newConfig = splitflapjs_proto_1.PB.SplitflapConfig.create(config);
    for (let i = 0; i < positions.length; i++) {
        if (positions[i] !== null) {
            newConfig.modules[i].targetFlapIndex = positions[i];
        }
        if (forceMovement !== undefined && forceMovement[i]) {
            newConfig.modules[i].movementNonce = ((newConfig.modules[i].movementNonce || 0) + 1) % 256;
        }
    }
    return newConfig;
};
exports.applySetFlaps = applySetFlaps;
const applyResetModules = (config, positions) => {
    if (positions.length > config.modules.length) {
        console.warn(`Ignoring applyResetModules: mismatch in positions specified (${positions.length}) vs config (${config.modules.length})!`);
        return config;
    }
    const newConfig = splitflapjs_proto_1.PB.SplitflapConfig.create(config);
    for (let i = 0; i < positions.length; i++) {
        if (positions[i]) {
            newConfig.modules[i].resetNonce = ((newConfig.modules[i].resetNonce || 0) + 1) % 256;
        }
    }
    return newConfig;
};
exports.applyResetModules = applyResetModules;
const applyResetModule = (config, position) => {
    const reset = new Array(position + 1);
    reset.fill(false);
    reset[position] = true;
    return (0, exports.applyResetModules)(config, reset);
};
exports.applyResetModule = applyResetModule;
function convert2dDualRowZigZagTo1dChainlink(arr, flipFirstRows = false) {
    const cols = arr[0].length;
    const rows = arr.length;
    const out = new Array(cols * rows);
    for (let i = 0; i < cols * rows; i++) {
        const rowPair = Math.floor(Math.floor(i / 2) / cols);
        const upsideDownRowPair = (rowPair + (flipFirstRows ? 1 : 0)) % 2 !== 0;
        const rowBase = rowPair * 2;
        const rowOffset = upsideDownRowPair ? i % 2 : 1 - (i % 2);
        const row = rowBase + rowOffset;
        const col = upsideDownRowPair ? cols - 1 - (Math.floor(i / 2) % cols) : Math.floor(i / 2) % cols;
        out[i] = arr[row][col];
    }
    return out;
}
exports.convert2dDualRowZigZagTo1dChainlink = convert2dDualRowZigZagTo1dChainlink;
function convert1dChainlinkTo2dDualRowZigZag(arr, cols, flipFirstRows = false) {
    const rows = Math.ceil(arr.length / cols);
    const out = new Array(rows);
    for (let i = 0; i < rows; i++) {
        out[i] = new Array(cols);
    }
    for (let i = 0; i < arr.length; i++) {
        const rowPair = Math.floor(Math.floor(i / 2) / cols);
        const upsideDownRowPair = (rowPair + (flipFirstRows ? 1 : 0)) % 2 !== 0;
        const rowBase = rowPair * 2;
        const rowOffset = upsideDownRowPair ? i % 2 : 1 - (i % 2);
        const row = rowBase + rowOffset;
        const col = upsideDownRowPair ? cols - 1 - (Math.floor(i / 2) % cols) : Math.floor(i / 2) % cols;
        out[row][col] = arr[i];
    }
    return out;
}
exports.convert1dChainlinkTo2dDualRowZigZag = convert1dChainlinkTo2dDualRowZigZag;
